import React, { useState } from "react";
import "./curriculumVitae.css";

const TEXTS = {
  es: {
    name: "// Víctor Barreto",
    role:
      "Desarrollador Full-Stack especializado en React y Node.js. Construyo aplicaciones web completas, enfocadas en UX, performance y mantenibilidad.",
    contact: "Contacto",
    experience: "Experiencia",
    skills: "Herramientas & Tecnologías",
    english: "Inglés",
    note: "Puedo compartir más detalles, links y responsabilidades por proyecto en entrevista.",
  },
  en: {
    name: "// Víctor Barreto",
    role:
      "Full-Stack Developer specialized in React and Node.js. I build complete web applications with a strong focus on UX, performance, and maintainability.",
    contact: "Contact",
    experience: "Experience",
    skills: "Tools & Technologies",
    english: "English",
    note: "More details, links, and responsibilities can be shared during an interview.",
  },
};

const CurriculumVitae = () => {
  const [lang, setLang] = useState("es");
  const t = TEXTS[lang];

  return (
    <div className="cv-container">
      <div className="cv-card">

        {/* Language toggle */}
        <div className="cv-lang">
          <button
            className={`lang-btn ${lang === "es" ? "active" : ""}`}
            onClick={() => setLang("es")}
          >
            ES
          </button>
          <button
            className={`lang-btn ${lang === "en" ? "active" : ""}`}
            onClick={() => setLang("en")}
          >
            EN
          </button>
        </div>

        {/* Header */}
        <div className="cv-top">
          <div>
            <h2 className="cv-name">{t.name}</h2>
            <p className="cv-role">{t.role}</p>

            <div className="cv-chiprow">
              <span className="badge">Full-Stack</span>
              <span className="badge">React</span>
              <span className="badge">Node.js</span>
              <span className="badge">JavaScript</span>
              <span className="badge">UX</span>
            </div>
          </div>
        </div>

        {/* Contact */}
        <section className="cv-section">
          <h3 className="cv-section-title">{`{ ${t.contact} }`}</h3>
          <ul className="cv-list">
            <li>
              Email:{" "}
              <a className="cv-link" href="mailto:titomanbarreto@gmail.com">
                titomanbarreto@gmail.com
              </a>
            </li>
            <li>
              Teléfono:{" "}
              <a className="cv-link" href="tel:+543516641124">
                +54 351 664 1124
              </a>
            </li>
            <li>Ubicación: Córdoba, Argentina</li>
            <li>
              GitHub:{" "}
              <a
                className="cv-link"
                href="https://github.com/vapretito"
                target="_blank"
                rel="noreferrer"
              >
                github.com/vapretito
              </a>
            </li>
            <li>
              LinkedIn:{" "}
              <a
                className="cv-link"
                href="https://www.linkedin.com/in/v%C3%ADctor-barreto-486487255/"
                target="_blank"
                rel="noreferrer"
              >
                linkedin.com/in/víctor-barreto
              </a>
            </li>
          </ul>
        </section>

        {/* Experience */}
        <section className="cv-section">
          <h3 className="cv-section-title">{`{ ${t.experience} }`}</h3>
          <ul className="cv-list">
            <li>
              <strong>Golat</strong> (2024–Actualidad) — Desarrollo web Full-Stack (PHP, JavaScript).
            </li>
            <li>
              <strong>CanchasYa</strong> (2023) — Proyecto Full-Stack (React, Node.js, PostgreSQL).
            </li>
            <li>
              <strong>Drivers (F1)</strong> (2023) — App de datos (React, PostgreSQL).
            </li>
            <li>
              <strong>VideoGames</strong> (2023) — SPA con APIs (React, JavaScript).
            </li>
            <li>
              <strong>Tarot</strong> (2025) — App interactiva con IA (HTML, JavaScript, Python).
            </li>
            <li>
              <strong>Uso Brackets</strong> (2018–2022) — Cajero / Community Manager.
            </li>
            <li>
              <strong>Mx Brackets</strong> (2020–2022) — Community Manager.
            </li>
          </ul>

          <p className="cv-note">{t.note}</p>
        </section>

        {/* Skills */}
        <section className="cv-section">
          <h3 className="cv-section-title">{`{ ${t.skills} }`}</h3>
          <ul className="cv-list">
            <li>React, JavaScript, HTML, CSS</li>
            <li>Node.js, Express, APIs REST</li>
            <li>PostgreSQL, SQL, Sequelize</li>
            <li>Git / GitHub, Deploy (Vercel / VPS)</li>
            <li>Photoshop (básico para UI/assets)</li>
          </ul>
        </section>

        {/* English */}
        <section className="cv-section">
          <h3 className="cv-section-title">{`{ ${t.english} }`}</h3>
          <ul className="cv-list">
            <li>EF SET English Certificate — 46/100 (B1 Intermediate)</li>
          </ul>
        </section>

      </div>
    </div>
  );
};

export default CurriculumVitae;
